@if (!loadingDashboard) {
    <app-header/>
    <ion-content>
        <ion-grid>
            <ion-row>
                <ion-col size="6" size-md="3">
                    <app-animated-dashboard-counter (click)="onChangeErrorClassification(ErrorClassification.TechnicalError)" [count]="errorCountsByCategory.amountOfTechnicalErrors"
                                           icon="bug-outline" iconColor="danger" [name]="'components.dashboard.counters.technicalErrors' | translate"/>
                </ion-col>
                <ion-col size="6" size-md="3">
                    <app-animated-dashboard-counter (click)="onChangeErrorClassification(ErrorClassification.FunctionalError)" [count]="errorCountsByCategory.amountOfFunctionalErrors"
                                           icon="help-outline" iconColor="warning" [name]="'components.dashboard.counters.functionalErrors' | translate"/>
                </ion-col>

                @if (isSuperTenant) {
                    <ion-col size="6" size-md="3">
                        <app-dashboard-counter [count]="totalAmountOfTenants" icon="people-outline" iconColor="success" [name]="'components.dashboard.counters.tenants' | translate"/>
                    </ion-col>
                    <ion-col size="6" size-md="3">
                        <app-dashboard-counter [count]="totalAmountOfTenantApplications" icon="apps-outline" iconColor="success" [name]="'components.dashboard.counters.applications' | translate"/>
                    </ion-col>
                }

            </ion-row>

            @if (showErrorList) {
                <ion-row>
                    <ion-col>
                        <app-dashboard-log-list [loading]="loadingErrors" [errors]="errors" [title]="logListTitle" [showTenantName]="isSuperTenant" />
                    </ion-col>
                </ion-row>
            }

            <ion-row >
                <ion-col size="12" size-md="6">
                    <app-dashboard-pivot-chart [title]="'components.dashboard.chart.titles.technical' | translate" [data]="technicalChartData" [isLoading]="isTechnicalChartLoading"
                                               (zoomIn)="onTechnicalZoomIn($event)" (zoomOut)="onTechnicalZoomOut()" [canZoomOut]="technicalChartCanZoomOut" />
                </ion-col>

                <ion-col size="12" size-md="6">
                    <app-dashboard-pivot-chart [title]="'components.dashboard.chart.titles.functional' | translate" [data]="functionalChartData" [isLoading]="isFunctionalChartLoading"
                                               (zoomIn)="onFunctionalZoomIn($event)" (zoomOut)="onFunctionalZoomOut()" [canZoomOut]="functionalChartCanZoomOut" />
                </ion-col>
            </ion-row>
        </ion-grid>
    </ion-content>
}
